/* adsSelector.tsx */
import PauseAdSelector from './pauseAdSelector';
import IMA from './ima/imaHandler';
import { adsSelector } from '@shared/store/slices/ads.slice';
import { useAppSelector } from '@shared/store/hooks';

/**
 * AdsSelector component.
 * Handles the selection of the appropriate ad handler based on the ad state.
 */
export default function AdsSelector() {
  const { videoAd } = useAppSelector(adsSelector);
  return (
    <>
      {videoAd ? <IMA /> : null}
      <PauseAdSelector />
      {/* {playAd?.active && !pauseAd ? <PlayTeads /> : null} */}
    </>
  );
}
